import React, { useEffect, useState } from "react"
import {
  Box,
  Button,
  InputAdornment,
  IconButton,
  Typography,
  Grid,
  FormControl,
  Input,
} from "@mui/material"
import { AiFillLock, AiFillUnlock } from "react-icons/ai"
import { useNavigate } from "react-router-dom"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import { MdVisibility, MdVisibilityOff } from "react-icons/md"
import { useResetPasswordMutation } from "../../features/Auth/authApi"
import mommylogo from "../../images/login-logo.png"
import baby1 from "../../images/baby1.png"
import baby2 from "../../images/baby3.png"
import baby3 from "../../images/babby3.png"
import baby4 from "../../images/babby4.png"
import { Controller, useForm } from "react-hook-form"
import CircularProgress from "@mui/material/CircularProgress"
import { updateToken } from "../../features/Auth/authSlice"
import { useAppDispatch } from "../../app/store"
import * as Style from "./style"
import { toast } from "react-toastify"
type Props = {}
interface resetUser {
  password: string
  confirmedPassword: string
}

interface IconProps {
  newPass: boolean
  confiPass: boolean
}

function ResetPassword({}: Props) {
  const [showPassword, setShowPassword] = React.useState<IconProps>({
    newPass: false,
    confiPass: false,
  })
  const [loading, setLoading] = useState(false)
  const dispatch = useAppDispatch()
  const [resetLogin, { isError, error, data }] = useResetPasswordMutation()

  const handleClickShowPassword = (key: any) => {
    setShowPassword((prevState: any) => ({
      ...prevState,
      [key]: !prevState[key] as any,
    }))
  }

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault()
  }

  const urlSearchParams = new URLSearchParams(window.location.search)
  const token = urlSearchParams.get("token")
  const navigate = useNavigate()
  dispatch(updateToken(token as any))
  const schemaResolver = yupResolver(
    yup.object().shape({
      password: yup
        .string()
        .required("Please Fill In A Password")
        .test(
          "Password-Length",
          "Password Must Be 8 characters Or More",
          (value: any) => value && (value as any).length >= 8,
        )
        .test(
          "Password-Strength",
          "Include At Least One Uppercase Letter, One Lowercase Letter, One Number, And One Special Character",
          (value) =>
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&~^])[A-Za-z\d@$!%*#?&~^]{8,}$/.test(
              value || "",
            ),
        ),
      confirmedPassword: yup
        .string()
        .required("Confirm Password Is A Required Field")
        .oneOf(
          [yup.ref("password"), ""],
          "New Password And Confirm Password Must Be Same",
        ),
    }),
  )
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<resetUser>({
    resolver: schemaResolver,
  })

  const onSubmit = (values: any) => {
    const payload = {
      password: values.password,
      confirmedPassword: values.confirmedPassword,
    }

    resetLogin(payload)
    setLoading(true)
  }

  useEffect(() => {
    if (data?.message) {
      toast.success(data?.message)
      navigate("/")
      setLoading(false)
    } else if ((error as any)?.data?.message) {
      toast.error((error as any)?.data?.message)
      setLoading(false)
    }
  }, [data, error])

  return (
    <Style.AuthPage>
      <Grid
        container
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Grid
          item
          lg={6}
          className="d-none d-lg-block"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Box className="box-wrapper">
            <Typography
              sx={{
                textAlign: "center",
                color: " #858585",
                fontFamily: "Montserrat",
                fontSize: "30px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "normal",
              }}
            >
              Welcome To
            </Typography>
            <Typography textAlign="center">
              <img src={mommylogo} width="300" height="auto" />
            </Typography>
            <Box
              className="Imgbox"
              display="flex"
              justifyContent="center"
              flexWrap="wrap"
              gap={2}
            >
              <Box>
                <img src={baby1} />
              </Box>
              <Box mt={5}>
                <img src={baby2} />
              </Box>

              <Box>
                <img src={baby3} />
              </Box>

              <Box mt={5}>
                <img src={baby4} />
              </Box>
            </Box>
          </Box>
        </Grid>

        <Grid item lg={6}>
          <Box className="Loginform">
            <Box>
              <Typography
                variant="h2"
                mt={2}
                mb={5}
                fontFamily="Montserrat"
                fontSize={22}
                fontWeight="600"
                color="pink.main"
                textAlign="center"
              >
                Create A New Password{" "}
              </Typography>{" "}
                  
              <form onSubmit={handleSubmit(onSubmit)}>
                <Box>
                    <FormControl
                      sx={{ mb: 2 }}
                      variant="outlined"
                      className="auth-field"
                      fullWidth
                    >
                      <Controller
                        name="password"
                        control={control}
                        render={({ field }: any) => (
                          <Input
                            {...field}
                            id="outlined-adornment-password"
                            type={showPassword?.newPass ? "text" : "password"}
                            endAdornment={
                              <InputAdornment position="start">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={() => handleClickShowPassword("newPass")}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="start"
                                >
                                  {showPassword?.newPass ? (
                                    <MdVisibility />
                                  ) : (
                                    <MdVisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            }
                            label="Password"
                            placeholder="New Password"
                            fullWidth
                            sx={{ mb: 0 }}
                          />
                        )}
                      />
                      <p className="text-danger">{errors?.password?.message}</p>
                    </FormControl>
                    <FormControl
                      sx={{ mt: 0 }}
                      variant="outlined"
                      className="auth-field"
                      fullWidth
                    >
                      <Controller
                        name="confirmedPassword"
                        control={control}
                        render={({ field }: any) => (
                          <Input
                            {...field}
                            id="outlined-adornment-password"
                            type={showPassword?.confiPass ? "text" : "password"}
                            endAdornment={
                              <InputAdornment position="start">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={() =>
                                    handleClickShowPassword("confiPass")
                                  }
                                  onMouseDown={handleMouseDownPassword}
                                  edge="start"
                                >
                                  {showPassword?.confiPass ? (
                                    <MdVisibility />
                                  ) : (
                                    <MdVisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            }
                            label="Confim Password"
                            placeholder="Confirm Password"
                            fullWidth
                          />
                        )}
                      />
                      <p className="text-danger">
                        {errors?.confirmedPassword?.message}
                      </p>
                    </FormControl>

                  <Button
                    type="submit"
                    size="large"
                    variant="contained"
                    className="auth-btn mx-auto"
                    sx={{ mt: 3, display: "block" }}
                    fullWidth
                  >
                    {loading ? (
                      <Typography fontSize={1}>
                        <CircularProgress
                          style={{ color: "white", fontSize: 23 }}
                          size={23}
                        />
                      </Typography>
                    ) : (
                      "Reset Password"
                    )}
                  </Button>
                  <Box mb={0} mt={3} className="text-center">
                  <Typography
                    sx={{ color: "#7B7B7B", margin: "8px 0 0 13px" }}
                    className="text-login"
                  >
                    Remember Your Password?{" "}
                    <Typography
                      component="span"
                      className="text-login text-black"
                      sx={{ color: "#181818", cursor: "pointer" }}
                      onClick={() => navigate("/")}
                    >
                      Sign In
                    </Typography>
                  </Typography>
                  </Box>
                </Box>
              </form>
            </Box>
          </Box>   
        </Grid>
      </Grid>
    </Style.AuthPage>
  )
}

export default ResetPassword
